import { render, staticRenderFns } from "./credentialsModal.vue?vue&type=template&id=54c70ac4&"
import script from "./credentialsModal.vue?vue&type=script&lang=js&"
export * from "./credentialsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "credentialsModal.vue"
export default component.exports